/**
 * activity-kind-pill.tsx — an activity's kind as a pill, for every screen that
 * draws one: the admin's campaign page and the student's activity and
 * gameplay views, whose pills were each written by hand, words and tone, six
 * times. Its words and tone are the kind table's (activity-kinds.ts). A value
 * off the wire the table does not know reads as itself, in neutral.
 *
 * In features/shell because the admin's screens and the student's both draw
 * it, and shell is the feature folder every role may read.
 */

import { useTranslation } from 'react-i18next';
import { Pill } from '../../components/pill';
import type { ActivityKind } from '../../api/_shared/types';
import { activityKindLook } from './activity-kinds';

/** An activity's kind as a pill: `sunken`, the recessed chip, where the student's views draw it on a card. */
export function ActivityKindPill({ kind, sunken = false }: { kind: ActivityKind; sunken?: boolean }) {
  const { t } = useTranslation();
  const { words, tone } = activityKindLook(kind, t);
  return (
    <Pill sunken={sunken} tone={tone}>
      {words}
    </Pill>
  );
}
